<template>
  <div class="">
    <div class="page-contain">
      <div class="page-contain-tab">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form label-position="top">
                      <el-form-item label="策略重点">
                          <span class="tooltip-header-text" slot="label">策略重点
                            <el-tooltip popper-class="custom-tooltip" placement="top">
                              <div slot="content" style="text-align: center;">策略描述指引（试运行）</div>
                              <div slot="content" class="tipsFormDivClass">● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。</div>
                              <div slot="content" class="tipsFormDivClass">● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词</div>
                              <div slot="content" class="tipsFormDivClass">● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；</div>
                              <div slot="content" class="tipsFormDivClass">● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；</div>
                              <div slot="content" class="tipsFormDivClass">● 特别注意推广及非推广类会议活动及项目的匹配度；</div>
                              <div slot="content" class="tipsFormDivClass">● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；</div>
                              <div slot="content" class="tipsFormDivClass">● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等</div>
                              <div slot="content" class="tipsFormDivClass">● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.</div>
                              <div slot="content" class="tipsFormDivClass">● 如业务团队有疑问，建议其及时咨询法务合规BP</div>
                              <i style="font-size: 16px" class="el-icon-warning-outline"></i>
                            </el-tooltip>
                          </span>
                          <el-input v-model="searchData.keynote"></el-input>
                      </el-form-item>
                      <el-row>
                          <el-col :span="5">
                              <el-form-item label="部门">
                                  <el-select @change="searchData.medicalField = '';searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.departId">
                                    <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="5">
                              <el-form-item label="Franchise/DA">
                                  <el-select @change="searchData.teamL4 = ''" clearable placeholder="请选择" v-model="searchData.medicalField">
                                    <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(searchData.departId, true))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="5">
                              <el-form-item label="团队">
                                  <el-select clearable placeholder="请选择" v-model="searchData.teamL4">
                                    <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(searchData.departId, searchData.medicalField, true))" :key="item.id" :value="item.id" :label="item.teamName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="9">
                              <el-form-item label="产品">
                                  <el-select filterable clearable placeholder="请选择（可搜索）" v-model="searchData.productId">
                                      <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                                      </el-option>
                                  </el-select>
                                  <el-button class="btn-search" type="primary" @click="handleSearch()">搜索</el-button>
                              </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>
              </div>
          </div>
          <div class="operate">
            <div>
              <a :href="'/static/file/strategy.xlsx?t='+new Date().getTime()">
                <el-button type="primary" plain>导出模板</el-button>
              </a>
              <span>
                <common-upload
                  :importApi="crudApi"
                  importType="Excel"
                  :onSuccess="handleUpdateSuccess"
                >
                  <el-button type="primary" plain>批量上传</el-button>
                </common-upload>
              </span>
              <el-button type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
              <el-button :disabled="selectedData.length <= 0" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
              <el-button type="primary" @click="handleAddNewClick()">添加策略</el-button>
            </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :searchDataLikeField="{'keynote':'*'}"
            :crudApi="crudApi"
            :tableData.sync="strategyData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :afterSave="handleStrategyChange"
            :afterDelete="handleStrategyChange"
            :selectedDataArray.sync="selectedData"
            :otherValid="validUpload"
            addSuccessMessages="添加策略成功"
            editSuccessMessages="编辑策略成功"
            deleteSuccessMessages="删除策略成功"
            deleteBatchSuccessMessages="批量删除策略成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>
              <el-table-column sortable prop="departId" label="部门">
              </el-table-column>
              <el-table-column sortable prop="medicalField" width="135">
                <template slot="header" slot-scope="scope">
                  <div style="display:inline-block">
                    <div>Franchise/DA</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable prop="teamL4" label="团队">
              </el-table-column>
              <el-table-column :formatter="formatBaseData" sortable prop="productId" label="产品">
              </el-table-column>
              <el-table-column sortable prop="keynote" label="策略重点">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="更新时间">
              </el-table-column>
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">策略重点</template>
            <template slot="editForm">
                <el-row>
                  <el-col>
                    <el-form-item required label="部门" prop="departId">
                        <el-select @change="addNewOrEditData.medicalField = '';addNewOrEditData.teamL4=''" placeholder="请选择" v-model="addNewOrEditData.departId">
                            <el-option v-for="item in (isConfigurationData ? departsList : userInfo.loginDeparts)" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="Franchise/DA" prop="medicalField">
                        <el-select @change="addNewOrEditData.teamL4=''" placeholder="请选择" v-model="addNewOrEditData.medicalField">
                            <el-option v-for="item in (isConfigurationData ? medicalFieldList : getMedicalFieldArray(addNewOrEditData.departId, false))" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="团队" prop="teamL4">
                        <el-select placeholder="请选择" v-model="addNewOrEditData.teamL4">
                          <el-option v-for="item in (isConfigurationData ? teamList : getTeamArray(addNewOrEditData.departId, addNewOrEditData.medicalField, false))" :key="item.id" :value="item.id" :label="item.teamName">
                          </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item required label="产品" prop="productId">
                        <el-select filterable placeholder="请选择（可搜索）" v-model="addNewOrEditData.productId">
                            <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item required label="策略重点名称（建议长度在8个字符以内）" prop="keynote">
                      <el-input rows="4" maxlength="200" type="textarea" v-model="addNewOrEditData.keynote" placeholder="请输入策略重点（建议长度在8个字符以内）"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
                <el-row>
                    <el-col>
                        <common-score
                            :disabledDownload="!canDownload"
                            ref="strategyHospital4Strategy"
                            title="策略重点与医院层级"
                            type="strategyHospital4Strategy"
                            fileName="策略重点与医院层级.xlsx"
                            :getExportParams="getScoreExportParams"
                        >
                        </common-score>
                    </el-col>
                    <el-col>
                        <common-score
                            :disabledDownload="!canDownload"
                            ref="strategyOffice"
                            title="策略重点与科室"
                            type="strategyOffice"
                            fileName="策略重点与科室.xlsx"
                            :getExportParams="getScoreExportParams"
                        >
                        </common-score>
                    </el-col>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加策略重点？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存策略重点？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除策略重点？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除策略重点？</span>
              </div>
            </template>
            <template slot="tipsFormMessage" class="tipsFormClass">
              <div slot="content">策略描述指引（试运行）</div>
              <div class="tipsFormDivClass">● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。</div>
              <div class="tipsFormDivClass">● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词</div>
              <div class="tipsFormDivClass">● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；</div>
              <div class="tipsFormDivClass">● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；</div>
              <div class="tipsFormDivClass">● 特别注意推广及非推广类会议活动及项目的匹配度；</div>
              <div class="tipsFormDivClass">● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；</div>
              <div class="tipsFormDivClass">● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等</div>
              <div class="tipsFormDivClass">● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.</div>
              <div class="tipsFormDivClass">● 如业务团队有疑问，建议其及时咨询法务合规BP</div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import strategy from '@/api/bizmanagement/strategy';
import { mapGetters, mapActions } from 'vuex';
import CommonScore from '../../../common/CommonScore.vue';
import * as orgUtil from '@/util/organizationUtil'
import bizmanagement from '@/api/bizmanagement/index';
export default {
  components: { CommonScore },
  data() {
    return {
      isConfigurationData:true,
      departsList :[],
      medicalFieldList :[],
      teamList :[],
      strategyData :[],
      searchData: {
        keynote:'',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      addNewOrEditData: {
        keynote: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
      },
      crudApi: strategy,
      selectedData: [],
      isEdit: false,
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetNameByRowIdField','userInfo']),
    canDownload() {
      return this.addNewOrEditData.departId && this.addNewOrEditData.medicalField && this.addNewOrEditData.teamL4 && this.addNewOrEditData.productId && this.addNewOrEditData.keynote;
    },
  },
  methods: {
    ...mapActions(['reloadBaseDataByType','initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalField, independ) {
      return orgUtil.teamArray(departId, medicalField, independ);
    },
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick() {
      if(this.$refs.strategyHospital4Strategy) {
        this.$refs.strategyHospital4Strategy.clearFile();
      }
      if(this.$refs.strategyOffice) {
        this.$refs.strategyOffice.clearFile();
      }
      this.$refs['crud'].handleAddNew();
      this.isEdit = false;
    },
    handleEditClick(item) {
      if(this.$refs.strategyHospital4Strategy) {
        this.$refs.strategyHospital4Strategy.clearFile();
      }
      if(this.$refs.strategyOffice) {
        this.$refs.strategyOffice.clearFile();
      }
      this.$refs['crud'].handleEdit(item);
      this.isEdit = true;
    },
    beforeSave(saveData) {
      saveData.departName = this.basedataGetName('Depart', saveData.departId);
      saveData.medicalFieldName = this.basedataGetName('MedicalField', saveData.medicalField);
      saveData.productName = this.basedataGetName('Product', saveData.productId);
      saveData.file = this.$refs.strategyHospital4Strategy.getFile()?this.$refs.strategyHospital4Strategy.getFile().raw:null;
      saveData.file2 = this.$refs.strategyOffice.getFile()?this.$refs.strategyOffice.getFile().raw:null;
    },
    validUpload() {
      let file1Valid = this.$refs.strategyHospital4Strategy.valid()
      let file2Valid = this.$refs.strategyOffice.valid();

      return file1Valid && file2Valid;
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('策略管理.xlsx');
    },
    handleUpdateSuccess() {
      this.handleSearch();
    },
    handleStrategyChange() {
      this.reloadBaseDataByType('Strategy');
    },
    getScoreExportParams() {
      let params = _.clone(this.addNewOrEditData);
      params.keynoteId = params.id;
      params.keynoteName = params.keynote;
      params.flag = this.isEdit?2:1;
      params.departName = this.basedataGetName('Depart', params.departId);
      params.medicalFieldName = this.basedataGetName('MedicalField', params.medicalField);
      params.productName = this.basedataGetName('Product', params.productId);

      return params;
    },
    getCustomizationArray(arr){
      if(arr.length > 0){
        const customizationArray = arr.map(ele => {
          const data = {
            id: ele,
            teamName: ele,
          }
          return data
        });
        return customizationArray
      }else return []
    }
  },
  mounted() {
    bizmanagement.queryBusDataOrg().then((res) => {
      this.isConfigurationData = res.isConfigurationData
        this.departsList = this.getCustomizationArray(res.departList)
        this.medicalFieldList = this.getCustomizationArray(res.medicalFieldList)
        this.teamList = this.getCustomizationArray(res.teamList)
        this.initBaseDataByTypes(['Depart','MedicalField','Product'])
        .then(() => {
          this.handleSearch();
        })
    })
    this.$refs['crud'].handleTips()
   
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 90%;
    }

    .btn-search {
      margin-left: 20px;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
  .tipsFormDivClass {
    text-align: left;
    font-weight: normal;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?a9e8bcaa